export const API_ROUTES = {
  home: {
    getHomeLayoutForAnonymousUser: `/v25/home/getHomeLayout`,
    getPlatterData: `/v24/home/getPlatterData`,
    top20Content: `/v24/home/top20Content`,
    getPremiumShows: `/v24/home/getPremiumShows`,
    continueWatchingTray: "/v1/tray/continue-watching",
    getNewShows: `/v24/home/getNewShows`,
    getWebSeries: `/v24/home/getWebSeries`,
    getRecommendationForYou: `/v24/home/getRecommendationForYou`,
    getTrendingContent: `/v24/home/getTrendingContentRow`,
    getPromotedContent: `/v24/home/promotedContent`,
    getAllContent: `/v24/home/all-content`,
    getHomeRowDetail: "/v25/home/getRow",
    getGenreList: "/v24/home/getGenreList",
    getCountryList: "/v20/home/getCountryList",
  },
  search: {
    searchResult: "/v23/search/search",
    trendingSearchRecords: "/v20/search/trendingSearchRecords",
  },
  consumption: {
    microDramaInteraction: "/contents/shows/micro-drama-interaction",
    getSignedUrl: "/v23/signedURL/getSignedURL",
    top20Content: `/v24/home/top20Content`,
    getShowDetails: "/contents/shows/details",
    exitWatchPage: "/v20/user/exitContentConsumption",
    getMovieDetails: "/contents/movies/details",
    postWatchVideoEvents: "/v1/event/watch-video",
    getSimilarShows: "v25/similar/getSimilarShow",
    getSimilarMovies: "v25/similar/getSimilarMovies",
    getSimilarMicroDramaContent: "v25/similar/getSimilarMicrodrama",
    getEpisodeSignedUrlWithoutLogin: (contentId: string) => {
      return `/contents/${contentId}/signedUrl`;
    },
    getSpecialAccessSignedUrl: "/contents/special-access/signedUrl",
    specialAccessUserState: "/contents/special-access/user-state",
    getSpecialAccessWebOfferPage: "/contents/special-access/web-offer-page",
  },
  payment: {
    getPhonepeMandate: `/v23/recurring-payments/createPhonePeMandet`,
    getJuspayMandate: `/v23/juspay-recurring/createAuthorizationTransaction`,
    getPaytmMandate: `/v23/recurring-payments/createPaytmMandate`,
    getCheckoutDetails: `/v23/recurring-payments/checkOutDetails`,
    getMandate: "/payments/mandate/create",
    transactionStatus: "/payments/mandate/txn-status",
    pauseMandate: "/payments/mandate/update",
    mandateStatus: "/payments/mandate/status",
    mandateDetails: "/users/subscription/details",
    getMandateDetails: "/users/subscription/sub-mandate-status",
    getRecurringSubscriptionStatus: `/v23/recurring-payments/recurringSubscriptionStatus`,
  },
  user: {
    getSettings: `/v23/settings/settings`,
    getSettingsCopies: `/v23/settings/copies`,
    getUserSubscriptionStatus: `/v23/user/getUserSubscriptionStatus`,
    getSubscriptionGlobalStatus: `/v20/subscription/getUserSubscriptionStatus`,
    getUserSubscriptionStatusV2: "/users/subscription/statusV2",
    getTrialPlans: `/v23/settings/trialPlans`,
    getOTP: `/v20/user/otp`,
    verifyOTP: `/v23/user/verifyOtp`,
    socialLogin: `/v20/user/socialLogin`,
    verifyTruecallerProfileStatus: `/v23/user/verifyTruecallerProfileStatus`,
    userSettings: `/v23/settings/user-settings`,
    verifyTvCode: "/v20/smartTv/verifyCode",
    generateTvCode: "/v20/smartTv/code",
    isTvLoginSuccessful: "/v23/smartTv/auth",
    getUserSubscriptionMandateStatus: "/users/subscription/sub-mandate-status",

    myList: "/v1/tray/watch-list", // all methods supported GET, POST, DELETE
    updateUserCulture: "/users/userCulture",
    updateUserDialect: "/v20/user/saveDialect",

    getLocation: "/v23/home/getUserLocation",

    // profile 👇
    profiles: "/users/profiles",
    getSwitchProfilesUrl: (profileId: string) => {
      return `/users/profiles/switch/${profileId}`;
    },
    getProfileUrl: (profileId: string) => {
      return `/users/profiles/${profileId}`;
    },
    getProfileFeatureContent: "/contents/profile-selection-contents",
  },
  content: {
    allContent: "/contents/allContents",
    genreDetails: "/contents/groupByGenre",
    getPromotionClip: `/contents/promotionClip`,
    contentWithCharacters: "/contents/content-with-characters",
    getContentDeeplink: (contentSlug: string) =>
      `/contents/deeplink/${contentSlug}`,
  },
  event: {
    updateUserProperties: `/v23/events/updateUserProperties`,
  },
  userEvents: "/users/user-events",
  messaging: {
    triggerWhatsAppMessage: `/v23/messaging/triggerWhatsapp`,
  },
  setting: {
    copies: `/v23/settings/copies`,
    getDialects: "/v23/settings/getDialects",
    getCultures: "/platform/config/userCultures",
  },
  stripe: {
    createCheckoutSession: `/subscription/checkout/session`,
  },
  partner: {
    partnerCouponDetails: `/v20/subscription/verifyCouponDetails`,
  },
  static: {
    pages: "/v20/staticContent/staticContentPages",
  },
  chat: {
    open: "/chat/open",
    send: "/chat/send",
    stream: "/chat/stream",
    messages: "/chat/messages",
    conversations: "/chat/conversations",
    home: "/chat/home",
    characters: "/chat/characters",
    getCharactersByShow: (showSlug: string) =>
      `/chat/series/${showSlug}/characters`,
    redirect: "/chat/redirect",
  },
};
